import { IdentityProviderService } from 'services/client-api-wrapper';
import { getApiGatewayUrl } from 'kits/urlKit';

export const idpService = new IdentityProviderService(getApiGatewayUrl('idp', 'default'));
